import React from 'react';
import ReactDOM from 'react-dom/client';

import { MsalProvider } from '@azure/msal-react';

import { msalInstance } from './auth/msalConfig';
import App from './App';
import './styles/index.css';
import './styles/print.scss';

async function bootstrap(): Promise<void> {
  await msalInstance.initialize();

  const response = await msalInstance.handleRedirectPromise();
  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  );
}

bootstrap();
